import Vue from 'vue';

import iView from '@td-analytics/iview-lite';
import cookie from 'js-cookie';
import i18n from './base/i18n';
import '@td-analytics/iview-lite/dist/styles/iview.css';
import AnalyticsPublic from './base/AnalyticsPublic';
import './assets/font-new/iconfont.css'
import StateHandler from './base/StateHandler';
import store from './store';
import App from './App';
import router from './router';
import bus from './libs/bus';
import BaseReq from './base/BaseReq';
import mainLib from './main-lib';
import BaseLib from './base/BaseLib';

mainLib.initState(store);

StateHandler.loadPublic();
i18n.locale = AnalyticsPublic.lang || 'zh-CN';

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});

if (location.pathname.indexOf('index.gray.html') !== -1) {
  // eslint-disable-next-line
  __webpack_public_path__ = '/spa-gray/app-analytics/';
}

// 设置语言
// let localLang = '';
// 判断浏览器的语言
const navLang = navigator.language;
const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false;
// 判断cookie的语言
const langTemp = cookie.get('i18next');
let cookieLang = '';
if (langTemp) cookieLang = langTemp === 'en_us' ? 'en-US' : 'zh-CN';
const lang = cookieLang || window.localStorage.getItem('language') || localLang || 'zh-CN';

bus.lang = lang;
bus.$on('on-change-lang', (language) => {
  i18n.locale = language;
  bus.lang = language;
  window.localStorage.setItem('language', language);
});

function getToken(route) {
  const routeToken = route.query.token;
  const cookieToken = cookie.get('_app_token_');
  if (route.name === 'productCenter') {
    if (routeToken && routeToken !== cookieToken) {
      cookie.set('_app_token_', routeToken, { expires: 7, path: '/' });
    }

    if (routeToken) {
      window.sessionStorage.setItem('_app_token_', routeToken);
    }
  }
  if (window.location.host === 'www.talkingdata.com' && !routeToken && !cookieToken) {
    const url = 'https://account.talkingdata.com/api/v1/center';
    setTimeout(() => {
      window.location.href = `${url}?languagetype=${bus.lang.toLowerCase().replace('-', '_')}`;
    }, 100);
  }
  Vue.prototype.$demo = (routeToken || cookieToken || '').indexOf('demo') > -1;
  // push demo环境变量
  window.demoViewFlag = Vue.$demo;
}

router.beforeEach((to, from, next) => {
  if (to.query._src !== 'outside' && to.query._init !== 'true') {
    const barEl = document.getElementsByClassName('scrollbar')[0];
    const scrollTop = barEl ? barEl.scrollTop : 0;
    BaseLib.postMessage('msg-gemini-menu', {
      path: to.path,
      scrollTop
    });
  }
  bus.productid = to.params.productid || '';
  // if (to.params.productid){
  //   bus.productid = to.params.productid;
  // }
  getToken(to);
  window.scrollTo(0, 0);
  next();
});

BaseReq.checkPermission().then(hasPermission => {
  if (!hasPermission) {
    document.getElementById('app').innerHTML = '<h1>未登录或没有访问权限</h1>';
    return;
  }
  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
});
